/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const InsertImageIcon = /*#__PURE__*/ createSvgIcon(
  'InsertImageIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.5 17c-.412 0-.766-.15-1.06-.448A1.452 1.452 0 013 15.5v-11c0-.403.147-.753.44-1.052A1.433 1.433 0 014.5 3h11c.412 0 .766.15 1.06.448.293.299.44.65.44 1.052v11c0 .403-.147.753-.44 1.052A1.433 1.433 0 0115.5 17h-11zm0-1.5h11v-11h-11v11zM6.25 14h7.504c.15 0 .26-.07.33-.208a.347.347 0 00-.042-.396l-2.25-3a.334.334 0 00-.292-.167.334.334 0 00-.292.167L9.25 13l-1.208-1.604a.334.334 0 00-.292-.167.334.334 0 00-.292.167l-1.496 2a.336.336 0 00-.04.396c.073.139.182.208.328.208zM7 8a.964.964 0 00.708-.292A.964.964 0 008 7a.964.964 0 00-.292-.708A.964.964 0 007 6a.964.964 0 00-.708.292A.964.964 0 006 7c0 .278.097.514.292.708.194.195.43.292.708.292z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default InsertImageIcon;
